import { v4 as uuidv4 } from 'uuid';


const sensors = {
  instance: null
};

if(process.browser){
  sensors.instance = window["sensorsDataAnalytic201505"];
}



// let showLog = true;
if (process.env.VUE_APP_MODE === "dev" || process.env.VUE_APP_MODE === "test") {
  showLog = true;
}

sensors.instance.init({
  server_url: process.env.VUE_APP_STAT_URL, // 数据接收地址
  is_track_single_page: true, // 单页应用页面浏览事件采集(url改变就触发)
  // use_app_track: false,
  show_log: process.env.NODE_ENV == "development" ||
            process.env.NODE_ENV == "test"
              ? true
              : false, // 控制台显示数据开
  heatmap: {
    // 热图设置 default开启 not_collect关闭（详细配置解释看官方文档）
    clickmap: "default", // 点击热图，收集点击事件
    scroll_notice_map: "default", // 视区热图，收集页面区域停留时间
  },
});

sensors.instance.registerPage({
  platform: "shanghaieye",
  user_agent_new: getUserAgent(),
  uuid: getUuid()
});
sensors.instance.quick("autoTrack"); // 首次触发页面加载事件 $pageview


function getUserAgent(){
  return navigator.userAgent.toLowerCase();
}

function getUuid(){
  let uuid = localStorage.getItem('uuid');
  if(!uuid){
   uuid = uuidv4();
   localStorage.setItem('uuid',uuid);
  }
  return uuid;
}



export default sensors;
